module.exports = __webpack_public_path__ + "img/房屋.2ffa791b.png";